define('models/ecard/balance',[ 'backbone' ], function(Backbone){

    var EcardBalance = Backbone.Model.extend({
        url: function(){
            return pf.consumerURL + '/eCards/GetGiftCardBalance/' + this.user_guid + '/' + this.giftcard_guid;
        },
        initialize: function(options){
            options || (options = {});
            
            this.user_guid = options.user_guid;
            this.giftcard_guid = options.giftcard_guid;
        },
        parse: function(data){
            var response = {};
            
            response.balance = data.B;
            response.balance_date = data.BDT;
            response.card_status = data.ECS;
            response.has_error = data.HE;
            response.error_message = data.EM;
            response.balance_changed = data.BC;

            return response;
        }
    });

    return EcardBalance;
});
